import i from './dashboard-user.container';

export default i;
